import { queryOptions } from '@tanstack/react-query'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import {
  KambiBetStatusQuery,
  getKambiPendingBetHistory,
  getKambiPendingBetsCashOutStatus,
} from '../api'

const enum LocalConstants {
  PollingTimeMs = 1_000 * 60 * 15, // 15mins
}

export const kambiPendingBetHistoryQuery = queryOptions({
  queryKey: [...queryKeys.kambiPlayerBetHistory, 'pending'],
  queryFn: getKambiPendingBetHistory,
  refetchOnWindowFocus: true,
  refetchOnMount: true,
  staleTime: LocalConstants.PollingTimeMs,
  refetchInterval: LocalConstants.PollingTimeMs,
})

export const kambiPendingBetsCashOutStatusQuery = queryOptions({
  queryKey: [...queryKeys.kambiPlayerBetHistory, 'pending', 'cashout-status'],
  queryFn: getKambiPendingBetsCashOutStatus,
  refetchOnWindowFocus: true,
  refetchOnMount: true,
  staleTime: LocalConstants.PollingTimeMs,
  refetchInterval: LocalConstants.PollingTimeMs,
})

export const kambiBetHistoryQuery = (status: KambiBetStatusQuery, enabled: boolean) =>
  queryOptions({
    queryKey: [...queryKeys.kambiPlayerBetHistory, 'my-bet', status.toLowerCase()],
    queryFn: getKambiPendingBetHistory,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    staleTime: LocalConstants.PollingTimeMs,
    refetchInterval: LocalConstants.PollingTimeMs,
    enabled,
  })
